module.exports = __webpack_public_path__ + "static/media/the-dutch_happy-hour.ca62e627.jpg";